import { flatMenu } from '../components/layout/Sidebar';

export type Breadcrumb = {
  name?: string;
  to?: string;
  parent?: string;
};

export const getBreadCrumbsByUrl = (url: string): Breadcrumb[] => {
  let path: string | undefined = url;
  const res: Breadcrumb[] = [];
  while (path !== undefined) {
    res.unshift(flatMenu?.[path]);
    path = flatMenu?.[path]?.parent;
  }
  return res;
};

export const getBreadCrumbsByUrlForEdit = (
  url: string,
  id: number
): Breadcrumb[] => {
  return [
    ...getBreadCrumbsByUrl(url),
    ...(id
      ? [{ to: `${url}${id}`, name: id.toString() }, { name: 'Редактирование' }]
      : [{ name: 'Новая запись' }])
  ];
};

export const getBreadCrumbsByUrlForCard = (
  url: string,
  id?: number
): Breadcrumb[] => {
  const crumb = id !== undefined && Number.isInteger(id)
    ? { to: `${url}${id}`, name: id.toString() }
    : {};
  return [...getBreadCrumbsByUrl(url), crumb];
};
